var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "recentOff",
    d: "M9.999 10.608h2.792a.526.526 0 1 1 0 1.053h-3.32a.526.526 0 0 1-.523-.58.533.533 0 0 1-.002-.048V6.6a.526.526 0 1 1 1.053 0v4.008zM2.094 3.875A9.99 9.99 0 0 1 10 0c5.523 0 10 4.476 10 9.999 0 5.523-4.478 10-10 10-5.523 0-10-4.477-10-10h1.053A8.948 8.948 0 1 0 2.84 4.632l1.384 1.403a.526.526 0 0 1-.375.896H.61a.526.526 0 0 1-.527-.526V3.119c0-.47.57-.704.9-.37l1.11 1.126z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "nonzero",
    xlinkHref: "#recentOff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentOff);
export default __webpack_public_path__ + "static/media/recent-off.6db8ac0c.svg";
export { ForwardRef as ReactComponent };